import classNames from 'classnames'
import { t } from 'i18next'
import { Controller, useFormContext } from 'react-hook-form'

import { FieldErrorMessage } from './FieldErrorMessage'
import { LogTimeFormData } from './types'
import { Input } from '@/Atomic/Molecules/Inputs/Input'
import { FormFields, FormGroup } from '@/Atomic/Templates/Form'

export const LogTimeFormBillingSection = () => {
  const { control, getFieldState } = useFormContext<LogTimeFormData>()

  return (
    <div className="container m-0 p-0 mw-100">
      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <FormGroup>
            <FormFields className="gap-1">
              <Controller
                name="billedDuration"
                control={control}
                render={({ field, fieldState: { error } }) => {
                  const { ref: _, ...restField } = field
                  return (
                    <Input
                      {...restField}
                      value={field.value}
                      name="billedDuration"
                      label={t('timeTracking.form.billedDuration')}
                      placeholder="0"
                      className="d-flex flex-column gap-2 w-100"
                      type="number"
                      step="0.5"
                      min="0"
                      max="24"
                      onWheel={(event) => event.currentTarget.blur()}
                      inputWrapperClassName={classNames({
                        'border-danger': error,
                      })}
                    />
                  )
                }}
              />
              {getFieldState('billedDuration').error && (
                <FieldErrorMessage
                  error={getFieldState('billedDuration').error}
                />
              )}
            </FormFields>
          </FormGroup>
        </div>
      </div>
      <div className="row mt-1">
        <div className="col-12 text-muted text-small fw-normal">
          {t('timeTracking.form.billingHint')}
        </div>
      </div>
    </div>
  )
}
